import { render, staticRenderFns } from "./formClientInstallationRisk.vue?vue&type=template&id=42266680&"
import script from "./formClientInstallationRisk.vue?vue&type=script&lang=js&"
export * from "./formClientInstallationRisk.vue?vue&type=script&lang=js&"
import style0 from "./formClientInstallationRisk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports